import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinInvestmentsComponent extends Component {
  @service organisation;

  get investments() {
    return this.args.investments;
  }

  get calculations() {
    return (this.investments?.calculations || []).map((calculation) => {
      return {
        ...calculation,
        type: calculation.type.toLowerCase().replaceAll('_', '-'),
      };
    });
  }

  get showTotal() {
    return this.calculations.filter((item) => item.confidence_value).length > 0;
  }

  @action
  addInvestment(type) {
    const investments = this.investments
      ? { ...this.investments }
      : { value: 0, calculations: [] };
    investments.calculations.push({
      type: type,
      confidence_label: 'Medium',
      confidence_value: this.organisation.bon_investment_confidences['medium'],
      notes: {},
    });
    this.args.updateBonInvestments(investments);
  }

  @action
  deleteInvestmentAtIndex(index) {
    const investments = { ...this.investments };
    investments.calculations.splice(index, 1);
    this.args.updateBonInvestments(investments);
  }

  @action
  onValueEmit(index, calculation) {
    const investments = { ...this.investments };
    investments.calculations[index] = calculation;
    this.args.updateBonInvestments(investments);
    this.args.checkForIncompleteTemplates();
  }

  @action
  onSlideoverToggle(key, type = null) {
    const joinedKey =
      type && typeof type === 'string' ? `${key}-${type}`.toLowerCase() : key;
    switch (joinedKey) {
      case 'ppw':
        this.args.togglePpwSlideover();
        break;

      case 'confidence-investment':
        this.args.toggleInvestmentConfidenceSlideover();
        break;
    }
  }

  @action
  handleAddFirstInvestment(type) {
    this.addInvestment(type);
    if (!this.args.editMode) this.args.toggleEditMode();
  }

  @action
  resetUnsavedChanges() {
    this.args?.resetBon?.();
  }

  @action
  handleAddCalculation(type) {
    this.args.toggleEditMode(true);
    this.addInvestment(type);
  }
}
